import { Action, createReducer, on } from '@ngrx/store';

import { Profession } from '@planone/bau365/util-fair-data';

import * as DataAccessProfessionsActions from './data-access-professions.actions';

export const DATA_ACCESS_PROFESSIONS_FEATURE_KEY = 'dataAccessProfessions';

export interface ProfessionsState {
  professions: KeyedProfessionState;
}

interface KeyedProfessionState {
  [uuid: string]: Profession;
}

export interface DataAccessProfessionsPartialState {
  readonly [DATA_ACCESS_PROFESSIONS_FEATURE_KEY]: ProfessionsState;
}

export const initialProfessionsState: ProfessionsState = {
  professions: {},
};

const dataAccessProfessionsReducer = createReducer(
  initialProfessionsState,
  on(DataAccessProfessionsActions.professionsLoadSucceeded, (state, { professions }) => {
    let updatedState = state;

    professions.forEach((profession) => {
      if (profession) {
        updatedState = {
          ...updatedState,
          professions: {
            ...(updatedState.professions ?? []),
            [profession.id]: profession,
          },
        };
      }
    });

    return updatedState;
  })
);

export function professionsReducer(state: ProfessionsState | undefined, action: Action) {
  return dataAccessProfessionsReducer(state, action);
}
